import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Button, Modal } from 'antd';
import { type CSSProperties, type FC, useState } from 'react';
import { NotificationBadge } from '../BasicComponents/NotificatioBadge/NotificationBadge';

interface Props {
  title?: string;
  buttonIcon: React.ReactNode;
  buttonText?: string;
  children: React.ReactNode;
  style?: CSSProperties;
  activ?: boolean;
}

export const BasicModal: FC<Props> = ({
  title = '',
  buttonIcon,
  buttonText = '',
  children,
  style = {},
  activ = false,
}) => {
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <div>
      <NotificationBadge show={activ}>
        <StyledButton
          onClick={showModal}
          icon={buttonIcon}
          style={style}
          size="small"
          type="default"
          activ={activ}
        >
          {buttonText}
        </StyledButton>
      </NotificationBadge>

      <Modal
        open={visible}
        onCancel={handleCancel}
        onOk={handleOk}
        title={title}
        footer={
          <>
            <Button onClick={handleCancel}>Close</Button>
            <Button type="primary" onClick={handleOk}>
              Ok
            </Button>
          </>
        }
        destroyOnHidden
      >
        {children}
      </Modal>
    </div>
  );
};

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'activ',
})<{ activ: boolean }>`
  ${({ activ }) =>
    activ
      ? `
    box-shadow: 0px 0px 5px 2px ${RacemapColors.PaleBlue};
    border-color: ${RacemapColors.PaleBlue};
  `
      : ''}
`;
